import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSquareComponent } from './simple-icons-square.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSquareComponent ],
    exports:      [ SimpleIconsSquareComponent ],
    bootstrap:    []
})
export class SimpleIconsSquareModule {}
